import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Field } from 'redux-form';

import { fetchUserWithholdingReportYear } from 'src/reducers/searchForm';
import { SearchSelectBox } from 'src/jbc-front/components/SearchForm';
import { arrowRenderer } from 'src/jbc-front/components/Form';
import { getSelectOptions } from 'src/reducers/selectOptions';

import styles from './YearSelector.scss';

const YearSelector = ({ fetchWithholdingReportYear, paymentYears }) => {
  useEffect(() => {
    fetchWithholdingReportYear();
  }, []);

  return (
    <div className={styles.selector}>
      <Field name="year" component={SearchSelectBox} options={paymentYears} arrowRenderer={arrowRenderer} />
    </div>
  );
};

const mapStateToProps = state => ({
  paymentYears: getSelectOptions(state, 'paymentYears')
});

const mapDispatchToProps = {
  fetchWithholdingReportYear: fetchUserWithholdingReportYear
};

export default connect(mapStateToProps, mapDispatchToProps)(YearSelector);
